<template>
  <v-simple-table class="bordered-table" dense>
    <template #default>
      <table-head :colspan="2" only-months="true">
        <template #thead>
          <th class="text-center header pa-1" colspan="2">
            <div class="text-black">
              {{ columnTitle }}
            </div>
          </th>
        </template>
      </table-head>
      <tbody>
        <table-body-loader v-if="loading" :colspan="25" />
        <template v-else>
          <tr class="first-row">
            <td rowspan="3">Total</td>
          </tr>
          <tr class="first-row">
            <td class="text-caption pa-1 w-0 item-iel-border">IEL</td>
            <template v-for="(total, subindex) in items.totals[metric]">
              <td
                :key="`amount-totals-iel-${subindex}`"
                class="text-caption pa-1 w-0 bg-white"
              >
                {{ formatNumber(total?.totalIEL, '$', 0) }}
              </td>
              <td
                :key="`pct-totals-iel-${subindex}`"
                class="text-caption pa-1 w-0 font-weight-bold bg-gray"
              >
                <span v-if="total.total != 0">
                  {{
                    formatFloat((total.totalIEL / total.total) * 100 ?? 0, 0)
                  }}%
                </span>
                <span v-else> 0%</span>
              </td>
            </template>
          </tr>
          <tr class="first-row">
            <td class="text-caption pa-1 w-0 item-iel-border">Otro</td>
            <template v-for="(total, subindex) in items.totals[metric]">
              <td
                :key="`amount-totals-sap-${subindex}`"
                class="text-caption pa-1 w-0 bg-white"
              >
                {{ formatNumber(total?.totalSAP, '$', 0) }}
              </td>
              <td
                :key="`pct-totals-sap-${subindex}`"
                class="text-caption pa-1 w-0 font-weight-bold bg-gray"
              >
                <span v-if="total.total != 0">
                  {{
                    formatFloat((total.totalSAP / total.total) * 100 ?? 0, 0)
                  }}%
                </span>
                <span v-else> 0% </span>
              </td>
            </template>
          </tr>
          <template v-for="(item, index) in items.data">
            <tr :key="`name-${index}`">
              <td rowspan="3" class="pa-2 w-0 item-name-border">
                <a class="pre-line text-black" @click="optionSelected(item)">
                  {{ item.label }}
                </a>
              </td>
            </tr>
            <tr :key="`options-iel-${index}`">
              <td class="text-caption pa-1 w-0 item-iel-border">IEL</td>
              <template v-for="(stats, subindex) in item.stats">
                <td
                  :key="`amount-IEL-${subindex}`"
                  class="text-caption pa-1 w-0 bg-white"
                >
                  {{ formatNumber(stats[metric].totalIEL, '$', 0) }}
                </td>
                <td
                  :key="`pct-IEL-${subindex}`"
                  class="text-caption pa-1 w-0 font-weight-bold bg-gray"
                >
                  {{ formatFloat(stats[metric].percentIEL, 0) }}%
                </td>
              </template>
            </tr>
            <tr :key="`options-sap-${index}`">
              <td class="text-caption pa-1 w-0 item-sap-border">Otro</td>
              <template v-for="(stats, subindex) in item.stats">
                <td
                  :key="`amount-oth-${subindex}`"
                  class="text-caption pa-1 w-0 font-weight-bold"
                >
                  {{ formatNumber(stats[metric].totalSAP, '$', 0) }}
                </td>
                <td
                  :key="`oth-IEL-${subindex}`"
                  class="text-caption pa-1 w-0 font-weight-bold bg-gray"
                >
                  {{ formatFloat(stats[metric].percentSAP, 0) }}%
                </td>
              </template>
            </tr>
          </template>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';
  import Helpers from '@/mixins/helpers';

  import TableHead from './TableHead.vue';
  import TableBodyLoader from '@/components/tables/TableBodyLoader.vue';

  export default {
    name: 'BillingTable',
    components: { TableHead, TableBodyLoader },
    mixins: [numbersFormats, Helpers],
    props: {
      items: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: true,
      },
      columnTitle: {
        type: String,
        default: 'Zona',
      },
      metric: {
        type: String,
        default: '',
      },
    },
    methods: {
      optionSelected(value) {
        this.$emit('optionSelected', value);
      },
    },
  };
</script>
<style scoped>
  .first-row td {
    background: #e0e0e0 0% 0%;
    border-color: #a6a3a3 !important;
    border-top-color: #e1e1e1 !important;
  }

  .bordered-table td {
    border: 1px solid #a6a3a3;
  }

  .item-name-border {
    border-width: 1px 0px 1px 1px;
  }

  .item-iel-border {
    border-width: 1px 1px 0px 0px;
  }

  .item-sap-border {
    border-width: 0px 1px 1px 0px;
  }
</style>
